export function promoCodeValidation (promoCode) {
  const allowedCharacters = ['9', '8', '2', '5', 'a', 'h', 'u', 'x', 'e', 'j']

  const promoCodeCh = promoCode.toLowerCase().split('')

  const allChIsCorrect = promoCodeCh.map((ch) => allowedCharacters.includes(ch))

  return allChIsCorrect.every((value) => value)
}
